import { PaperContainer } from "containers";
import styled, { keyframes } from "styled-components";

export const Container = styled(PaperContainer)`
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
`;

export const Header = styled.div`
  display: flex;
  min-height: 64px;
  justify-content: space-between;
  align-items: center;
  padding: 0 18px;
  cursor: pointer;
  gap: 16px;
`;

export const Name = styled.div`
  font-size: ${(props) => props.theme.fontSizes.subtitle1FontSize};
  color: ${(props) => props.theme.colors.primaryBlack};
  font-weight: ${(props) => props.theme.fontWeights.normalFontWeight};
`;

export const Chevron = styled.div<{ $expanded?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  font-size: ${(props) => props.theme.fontSizes.heading6FontSize};
  color: ${(props) => props.theme.colors.secondaryGrey};
  transform: rotate(${(props) => (props.$expanded ? "180deg" : "0deg")});
  transition: transform 0.2s ease;
`;

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const Loader = styled.span`
  width: 16px;
  height: 16px;
  border: 2px solid ${(props) => props.theme.colors.secondaryLightGray};
  border-top-color: ${(props) => props.theme.colors.primaryGreen};
  border-radius: 50%;
  animation: ${spin} 0.7s linear infinite;
`;

export const Body = styled.div`
  padding: 0 18px 18px;
  border-top: 1px solid ${(props) => props.theme.colors.secondaryLightGray};
`;

export const DocHtml = styled.div`
  padding-top: 16px;
  font-size: ${(props) => props.theme.fontSizes.subtitle1FontSize};
  color: ${(props) => props.theme.colors.primaryBlack};
  line-height: 1.6;
  word-break: break-word;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: ${(props) => props.theme.fonts.mainBoldFont};
    margin: 20px 0 8px;
    line-height: 1.3;
  }

  h1 {
    font-size: ${(props) => props.theme.fontSizes.heading4FontSize};
  }
  h2 {
    font-size: ${(props) => props.theme.fontSizes.heading5FontSize};
  }
  h3 {
    font-size: ${(props) => props.theme.fontSizes.heading6FontSize};
  }
  h4,
  h5,
  h6 {
    font-size: ${(props) => props.theme.fontSizes.heading7FontSize};
  }

  p {
    margin: 0 0 12px;
  }

  ul,
  ol {
    margin: 0 0 12px;
    padding-left: 22px;
  }

  li {
    margin-bottom: 6px;
  }

  a {
    color: ${(props) => props.theme.colors.primaryGreen};
    text-decoration: underline;
  }

  blockquote {
    margin: 0 0 12px;
    padding: 8px 16px;
    border-left: 3px solid ${(props) => props.theme.colors.secondaryLightGray};
    color: ${(props) => props.theme.colors.secondaryGrey};
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 0 0 12px;
  }

  th,
  td {
    border: 1px solid ${(props) => props.theme.colors.secondaryLightGray};
    padding: 8px 10px;
    text-align: left;
  }

  hr {
    border: none;
    border-top: 1px solid ${(props) => props.theme.colors.secondaryLightGray};
    margin: 16px 0;
  }

  img {
    max-width: 100%;
    height: auto;
  }
`;
